import { render, staticRenderFns } from "./Insights.html?vue&type=template&id=c8d31a26&scoped=true&external"
import script from "./Insights.js?vue&type=script&lang=js&external"
export * from "./Insights.js?vue&type=script&lang=js&external"
import style0 from "./Insights.scss?vue&type=style&index=0&id=c8d31a26&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d31a26",
  null
  
)

export default component.exports